import { render, staticRenderFns } from "./DeleteRecordItemPop.vue?vue&type=template&id=883366b0&"
import script from "./DeleteRecordItemPop.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordItemPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports